import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "fixed inset-x-0 top-0 z-[100] border-b border-border-subtle bg-[rgba(249,246,240,0.8)] backdrop-blur-md" }
const _hoisted_2 = { class: "mx-auto grid h-[72px] max-w-page grid-cols-[1fr_auto_1fr] items-center px-6 lg:px-10" }
const _hoisted_3 = { class: "justify-self-start" }
const _hoisted_4 = { class: "flex items-center justify-center gap-10" }
const _hoisted_5 = { class: "justify-self-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SiteHeaderLink = _resolveComponent("SiteHeaderLink")!
  const _component_LuxuryButton = _resolveComponent("LuxuryButton")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/#header",
          class: "font-interface text-base font-medium uppercase tracking-[0.2em] text-text-primary transition-colors duration-cinematic ease-luxury hover:opacity-80"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" SNAPSHARE ")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("nav", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navLinks, (link) => {
          return (_openBlock(), _createBlock(_component_SiteHeaderLink, {
            key: link.url,
            link: link
          }, null, 8, ["link"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.ctaLink)
          ? (_openBlock(), _createBlock(_component_LuxuryButton, {
              key: 0,
              variant: "compact",
              size: "md",
              to: _ctx.ctaLink.url
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.ctaLink.text), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}